<template>
  <div class="calculator__calculator">
    <h2>Kalkulator rat.</h2>
    <div class="calculator__calculator__columns">
      <div class="calculator__calculator__columns__column inputs">
        <div class="calculator__calculator__columns__column__input">
          <label for="payment"
            >Opłata wstępna:
            <output
              >{{
                Math.round(this.initialPay).toLocaleString("pl-PL")
              }} </output
            >&nbsp;zł
          </label>
          <input
            @input="this.onInput('payment')"
            type="range"
            :min="this.chosenCar.payments[0]"
            :max="this.chosenCar.payments.at(-1)"
            v-model="this.calculator.payment"
            id="payment"
            :step="this.chosenCar.payments[1] - this.chosenCar.payments[0]"
            list="preliminary_payments"
            data-change="no"
          />
          <div class="datalist" id="preliminary_payments">
            <div
              class="option"
              v-for="(val, index) in this.chosenCar.payments"
              :key="index"
              :value="val * 100"
            >
              {{ val * 100 }}%
            </div>
          </div>
        </div>
        <div class="calculator__calculator__columns__column__input">
          <label for="rates">Okres finansowania w miesiącach </label>
          <input
            @input="this.onInput('rates')"
            type="range"
            :min="this.chosenCar.rates[0]"
            :max="this.chosenCar.rates.at(-1)"
            v-model="this.calculator.rate"
            id="rates"
            :step="this.chosenCar.rates[1] - this.chosenCar.rates[0]"
            list="preliminary_rates"
          />
          <div class="datalist" id="preliminary_rates">
            <div
              class="option"
              v-for="(val, index) in this.chosenCar.rates"
              :key="index"
              :value="val"
            >
              {{ val }}
            </div>
          </div>
        </div>
        <div class="calculator__calculator__columns__column__input">
          <label for="kilometers">Roczny limit kilometrów w tysiącach </label>
          <input
            @input="this.onInput('kilometers')"
            type="range"
            :min="parseInt(this.chosenCar.km_limits[0])"
            :max="parseInt(this.chosenCar.km_limits.at(-1))"
            v-model="this.calculator.km_limits"
            id="kilometers"
            :step="
              parseInt(this.chosenCar.km_limits[1]) -
              parseInt(this.chosenCar.km_limits[0])
            "
            list="preliminary_km"
          />
          <div class="datalist" id="preliminary_km">
            <div
              class="option"
              v-for="(val, index) in this.chosenCar.km_limits"
              :key="index"
              :value="val / 1000"
            >
              {{ val / 1000 }}
            </div>
          </div>
        </div>
        <div class="calculator__calculator__columns__column__rate">
          <h2 class="rate">
            <output>
              {{ Math.round(this.leaseRate).toLocaleString("pl-PL") }}
            </output>
            <span v-if="this.chosenCar.type == 'porsche_leasing_jak_abonament'">
              zł netto/miesiąc
            </span>
            <span
              v-else-if="this.chosenCar.type == 'porsche_kredyt_jak_abonament'"
            >
              zł brutto/miesiąc
            </span>
          </h2>
          <p v-if="this.chosenCar.type == 'porsche_leasing_jak_abonament'">
            Leasing JAK ABONAMENT
          </p>
          <p v-else-if="this.chosenCar.type == 'porsche_kredyt_jak_abonament'">
            Kredyt JAK ABONAMENT
          </p>
        </div>
        <div class="calculator__calculator__columns__column__buttons">
          <div class="calculator__calculator__columns__column__buttons__button">
            <a href="#kontakt"
              ><span
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12.005"
                  height="20.306"
                  viewBox="0 0 12.005 20.306"
                >
                  <path
                    id="Path_553"
                    data-name="Path 553"
                    d="M156.411,698.485l8.075,10.069-4.767,6.043-3.308,4.194h-3.93l8.226-10.237-8.226-10.069Z"
                    transform="translate(-152.481 -698.485)"
                    fill="#fff"
                  />
                </svg>
                Zamów kontakt</span
              ></a
            >
          </div>
          <p>
            lub skontaktuj się z infolinią:
            <a href="tel:+48225289799">22 528 97 99</a>
          </p>
        </div>
      </div>
      <div class="calculator__calculator__columns__column slider">
        <img
          :src="this.$parent.getImgUrl(this.chosenCar.model)"
          :alt="this.chosenCar.model"
        />
        <p>{{ this.chosenCar.model }}</p>
        <p>
          <VueNumberFormat
            v-model:value="this.calculator.price"
            :options="{
              precision: 0,
              prefix: '',
              suffix: '',
              decimal: '',
              thousand: ' ',
              acceptNegative: false,
              isInteger: false,
            }"
          ></VueNumberFormat>
          <span>zł (brutto)</span>
        </p>
        <p class="nobold">
          <input
            type="text"
            readonly
            :value="this.toNettoPrice(this.calculator.price)"
          />
          <span>zł (netto)</span>
        </p>
        <div class="calculator__calculator__columns__column__swiper">
          <swiper
            :modules="modules"
            :slides-per-view="3"
            :breakpoints="this.opts.breakpoints"
            :space-between="25"
            navigation
            @swiper="onSwiper"
            @slideChange="onSlideChange"
          >
            <swiper-slide
              v-for="(car, index) in cars"
              :key="index"
              @click="this.changeCar(car.name)"
            >
              <div class="calculator__calculator__carousel__swiper__slide">
                <img :src="this.$parent.getImgUrl(car.name)" :alt="car.name" />
                <h4>{{ car.name }}</h4>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
export default {
  name: "CalculatorComponent",
  props: ["cars", "chosenCar", "rateToPay", "swiperOptions"],
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      calculator: {
        price: this.chosenCar.price,
        payment: Number(this.chosenCar.payment),
        rate: this.chosenCar.rate,
        km_limits: parseInt(this.chosenCar.km_limit),
      },
      initialPay: 0,
      leaseRate: 0,
      opts: {
        breakpoints: {
          300: {
            slidesPerView: 2,
            spaceBetween: 25,
          },
          750: {
            slidesPerView: 2,
            spaceBetween: 25,
          },
          1100: {
            slidesPerView: 3,
            spaceBetween: 25,
          },
        },
      },
    };
  },
  setup() {
    // eslint-disable-next-line no-unused-vars
    const onSwiper = (swiper) => {};
    const onSlideChange = () => {};
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation],
    };
  },
  mounted() {
    const inputs = document.querySelectorAll(
      '.calculator__calculator__columns__column__input input[type="range"]'
    );
    inputs.forEach((el) => {
      this.onInput(el.id);
    });
    this.initialPay = this.calculator.price * this.calculator.payment;
    this.leaseRate = this.rateToPay;
  },

  watch: {
    chosenCar: {
      handler(val) {
        const inputs = document.querySelectorAll(
          '.calculator__calculator__columns__column__input input[type="range"]'
        );
        this.calculator = {
          price: Number(val.price.toLocaleString("pl-PL")),
          payment: Number(val.payment),
          rate: val.rate,
          km_limits: parseInt(val.km_limit),
        };
        const inputChange = document.getElementById("payment");
        if (inputChange) {
          inputChange.dataset.change = "yes";
        }
        setTimeout(() => {
          inputs.forEach((el) => {
            this.onInput(el.id);
          });
        }, 1);
      },
      deep: true,
      immediate: true,
    },
    calculator: {
      deep: true,
      immediate: true,
      handler(val, old) {
        if (old) {
          let newRate = {
            type: this.chosenCar.type,
            model: this.chosenCar.model,
            price: Number(val.price),
            km_limit: parseInt(val.km_limits),
            rate: val.rate,
            payment: Number(val.payment),
            initial: 1,
          };
          this.$parent.fetchLoan(newRate);
        }
      },
    },
    payment(val, oldVal) {
      this.calculatePrice(val, oldVal, "payment");
    },
    price(val, oldVal) {
      this.calculatePrice(val, oldVal, "price");
    },
    rateToPay(val, oldVal) {
      const counter = setInterval(() => {
        if (val > oldVal) {
          const step = (val - oldVal) / 4;
          this.leaseRate += step;
        } else if (val < oldVal) {
          const step = (oldVal - val) / 4;
          this.leaseRate -= step;
        }
        this.leaseRate == val ? clearInterval(counter) : "";
      }, 50);
    },
  },
  computed: {
    price() {
      return this.calculator.price;
    },
    payment() {
      return this.calculator.payment;
    },
  },
  methods: {
    toNettoPrice(num) {
      return Math.round(num / 1.23).toLocaleString("pl-Pl");
    },
    calculatePrice(val, oldVal, type) {
      const to =
        type == "price"
          ? val * this.chosenCar.payment
          : this.calculator.price * val;
      const from =
        type == "price"
          ? oldVal * this.chosenCar.payment
          : this.calculator.price * oldVal;
      const input = document.getElementById("payment");
      const change = type == "price" ? "yes" : "no";
      if (input.dataset.change == change) {
        input.disabled = true;
        let i = 0;
        const counter = setInterval(() => {
          i++;
          if (val > oldVal) {
            const step = (to - from) / 5;
            this.initialPay += step;
          } else if (val < oldVal) {
            const step = (from - to) / 5;
            this.initialPay -= step;
          }
          if (i == 5) {
            clearInterval(counter);
            this.initialPay = to;
            input.disabled = false;
          }
        }, 70);
      } else {
        input.dataset.change = change;
      }
    },
    onInput(id) {
      const slider = document.getElementById(id);
      if (slider) {
        const min = slider.min;
        const max = slider.max;
        const value = slider.value;
        slider.style.background = `linear-gradient(to right, #000 0%, #000 ${
          ((value - min) / (max - min)) * 100
        }%, #DEE2E6 ${((value - min) / (max - min)) * 100}%, #DEE2E6 100%)`;
      }
    },
    changeCar(car) {
      this.$parent.chosenCar = car;
    },
  },
};
</script>
